<ng-container *ngIf="filled" i18n="etat offre emploi|offre pourvue"> Pourvu </ng-container>

<ng-container *ngIf="newed" i18n="etat offre emploi|nouvelle offre"> Nouveau </ng-container>

<ng-container *ngIf="expiring" i18n="etat offre emploi"> Expire bientôt </ng-container>

<ng-container *ngIf="!filled && !newed && !expiring" i18n="etat offre emploi|offre posté il y a X jours">
  Il y a <span class="days">{{ days }} jours</span>
</ng-container>
